import React from 'react';
import { Card, CardContent } from './ui/Card';
import { UsersIcon, PhoneIcon, CheckCircleIcon, TrendingUpIcon, TrendingDownIcon, ArrowUpRightIcon, ArrowDownRightIcon } from 'lucide-react';
interface Stat {
  label: string;
  value: string;
  change?: string;
  trend?: 'up' | 'down' | 'neutral';
  icon: React.ElementType;
  color: string;
  borderColor: string;
}
export function StatsBar() {
  const stats: Stat[] = [{
    label: 'Total Leads in Dialer',
    value: '2,845',
    change: '+12% from last week',
    trend: 'up',
    icon: UsersIcon,
    color: 'text-blue-600 bg-blue-50',
    borderColor: 'border-l-blue-500'
  }, {
    label: 'Active Campaigns',
    value: '8',
    change: '2 paused',
    trend: 'neutral',
    icon: TrendingUpIcon,
    color: 'text-purple-600 bg-purple-50',
    borderColor: 'border-l-purple-500'
  }, {
    label: 'Avg Contact Rate',
    value: '18.4%',
    change: '+2.1% increase',
    trend: 'up',
    icon: PhoneIcon,
    color: 'text-emerald-600 bg-emerald-50',
    borderColor: 'border-l-emerald-500'
  }, {
    label: 'Qualified Today',
    value: '42',
    change: '15 pending review',
    trend: 'up',
    icon: CheckCircleIcon,
    color: 'text-orange-600 bg-orange-50',
    borderColor: 'border-l-orange-500'
  }];
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-152">
      {stats.map((stat, index) => <Card key={index} className={`border-l-4 ${stat.borderColor}`} data-id="element-153">
          <CardContent className="flex items-start justify-between p-5" data-id="element-154">
            <div data-id="element-155">
              <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-156">
                {stat.label}
              </p>
              <h3 className="text-3xl font-bold text-gray-900 tracking-tight" data-id="element-157">
                {stat.value}
              </h3>
              {stat.change && <div className="flex items-center mt-2" data-id="element-158">
                  {stat.trend === 'up' ? <ArrowUpRightIcon className="w-3.5 h-3.5 text-emerald-600 mr-1" data-id="element-159" /> : stat.trend === 'down' ? <ArrowDownRightIcon className="w-3.5 h-3.5 text-red-600 mr-1" data-id="element-160" /> : null}
                  <p className={`text-xs font-medium ${stat.trend === 'up' ? 'text-emerald-600' : stat.trend === 'down' ? 'text-red-600' : 'text-gray-500'}`} data-id="element-161">
                    {stat.change}
                  </p>
                </div>}
            </div>
            <div className={`p-3 rounded-xl ${stat.color}`} data-id="element-162">
              <stat.icon className="w-5 h-5" data-id="element-163" />
            </div>
          </CardContent>
        </Card>)}
    </div>;
}